import React, { Component } from 'react';
import DataTables from './DataTables';
import Cookie from 'js-cookie';
import { Config } from './../config/config';
import Menu from './Menu';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import { Navigate } from 'react-router-dom';
import DoughNut from './Charts/DoughNut';
import LineChart from './Charts/LineChart';
import PolarChart from './Charts/PolarChart';
//import DataDownLoad from './DataDownload';
import Multi from './MultiSearch';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import StackedBar from './Charts/StackedBar';
import { RETAIL_EVACUATIONS } from './../Utilities/AppData/Evacuations';
import { RETAIL_HANDOVERS } from '../Utilities/AppData/Handovers/RetailHandovers';
import { RETAIL_NONCONFORMITIES } from '../Utilities/AppData/Nonconformities/RetailNonconformities';
import { FIND_DUPLICATES } from '../Utilities/AppData/FindDuplicates';
import { RETAIL_INCIDENTS } from '../Utilities/AppData/Incidents/RetailIncidents';
import { SAFTEY_GLOBAL } from './SafetyRegister/SafetyRegisterData';
import { RETAIL_TRAINING_GLOBAL } from '../Utilities/AppData/Training/RetailTrainingGlobal';
import { Link } from 'react-router-dom';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';
import LZString from 'lz-string';


console.disableYellowBox = true;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user['moduleAccess'];
    let userID = user['userId'];
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('warehouse_tabName');
    const config = JSON.parse(Config);
    let cities = JSON.parse(localStorage.getItem('CitiesForStores'));

    this.state = {
      title: 'Global Dashboard - Retail',
      incno: [],
      incidentTypeNo: [],
      closure: [],
      alerts: [],
      alertno: [],
      proxyJsonWeeklyCheckList: [],
      proxyJsonMonthlyCheckList: [],
      userID,
      user: menu,
      incidentsMC: [],
      apiInterface: config['api'],
      proxyjson: [],
      proxyjson1: [],
      proxyjson2: [],
      proxyjson3: [],
      proxyjson4: [],
      proxyjson5: [],
      navigate1: false,
      loading: false,
      month: config['month'],
      //currentMonth: 12,
      //currentyear: 2020,
      currentMonth: new Date().getMonth() + 1,
      currentyear: new Date().getFullYear(),
      years: config['years'],
      cities,
      currentCity: localStorage.getItem('currentCityForDashboard')
        ? localStorage.getItem('currentCityForDashboard')
        : '',
      cityChanged: false,
      multiSearch: '',
      activeTab: '',
      storSearch: [],
      searchValue: false,
      pageLoad: false,
      storeCityEnabled: false,
      warehouseCityEnabled: false,
      pageAllowed: false,
      stores: [],
      warehouses: [],
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(
    index,
    userID = this.state.userID,
    month = this.state.currentMonth,
    year = this.state.currentyear
  ) {
    localStorage.setItem('store_tabName', index);
    this.setState({
      activeTab: index,
      loading: true,
    });

    if (index === 0) {
      RETAIL_EVACUATIONS('/fetchZoneEvacuationReport', userID, month, year)
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }

          this.setState({
            proxyjson: response,
            loading: false,
          });
          console.log('Evacuation data are generated');
          // console.clear();
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (index === 1) {
      let alerts = [];
      let incidentTypes = [];
      RETAIL_INCIDENTS('/fetchZoneIncidentsReport', userID, month, year)
        .then((response) => {
          response.incidentInfos.map((name) => {
            alerts.push(name.alertLevel);
            incidentTypes.push(name.incidentType);
          });

          var counts = {};
          alerts.sort().forEach(function (x) {
            counts[x] = (counts[x] || 0) + 1;
          });

          var inccounts = {};
          incidentTypes.sort().forEach(function (x) {
            inccounts[x] = (inccounts[x] || 0) + 1;
          });

          this.setState({
            incno: inccounts,
            incidentTypeNo: FIND_DUPLICATES(incidentTypes),
            alerts: FIND_DUPLICATES(alerts),
            alertno: counts,
            closure: response.closure,
            proxyjson: response,
            loading: false,
          });
          console.log('Incidents data are generated');
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (index === 2) {
      RETAIL_HANDOVERS('/fetchHandoverGlobalDashboards', userID, month, year)
        .then((response) => {
          this.setState({
            proxyjson: response['proxyjson'],
            proxyJsonWeeklyCheckList: response['proxyJsonWeeklyCheckList'],
            proxyJsonMonthlyCheckList: response['proxyJsonMonthlyCheckList'],
            loading: false,
          });
          console.log('Handovers data are generated');
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (index === 3) {
      RETAIL_NONCONFORMITIES(
        '/fetchGlobalNonConfirmityDashboardRetail',
        userID,
        month,
        year
      )
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }
          this.setState({
            proxyjson: response['proxyjson'],
            proxyJsonWeeklyCheckList: response['proxyJsonWeeklyCheckList'],
            loading: false,
          });
          console.log('Non confirmity data are generated');
          console.log(JSON.stringify(response['proxyjson']));
          console.log(JSON.stringify(response['proxyJsonWeeklyCheckList']));
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (index === 4) {
      SAFTEY_GLOBAL(
        '/loadSafetyRegisterGlobalDashboard',
        userID,
        month,
        year,
        'Store'
      )
        .then((response) => {
          this.setState({
            proxyjson4: response,
            loading: false,
          });
          console.log('Safety register data are generated');
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: false,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else if (index === 5) {
      RETAIL_TRAINING_GLOBAL(
        '/fetchTrainingGlobalDashboardRetail',
        userID,
        month,
        year
      )
        .then((response) => {
          this.setState({
            proxyjson5: response,
            loading: false,
          });
          console.log('Training data are generated');
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: false,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    }
  }

  handleMonthChange = (e) => {
    this.setState({
      currentMonth: e.target.value,
    });
    console.log('Month is changed');
    this.handleSelect(
      this.state.activeTab,
      this.state.userID,
      e.target.value,
      this.state.currentyear
    );
  };

  handleYearChange = (e) => {
    this.setState({
      currentyear: e.target.value,
    });
    console.log('Year is changed');
    this.handleSelect(
      this.state.activeTab,
      this.state.userID,
      this.state.currentMonth,
      e.target.value
    );
  };
  handleCityChange = (e) => {
    this.setState({
      currentCity: e.target.value,
      cityChanged: true,
    });
    console.log('City is changed');
    // localStorage.setItem(
    //   'multisearch',
    //   JSON.stringify({ type: 'retail', data: [] })
    // );
    ApiGateWay.Post(this.state.apiInterface + `/fetchStoreInfo`, {
      userId: this.state.userID,
      cityIds: e.target.value,
      appType: 'Web',
    })
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }

        if (response['storesInfos'][0]['storeType'] === 'Store') {
          localStorage.setItem(
            'storeData1',
            JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
          );

          this.setState({
            navigate1: true,
            stores: response['storesInfos'][0]['storeLocationsInfos'],
          });
        } else {
          localStorage.setItem(
            'storeData1',
            JSON.stringify(response['storesInfos'][1]['storeLocationsInfos'])
          );
          this.setState({
            navigate1: true,
            stores: response['storesInfos'][1]['storeLocationsInfos'],
          });
        }
      })
      .catch(() => {
        this.setState({
          modalOpen: !this.state.modalOpen,
          message: 'Something went wrong please try again after sometime',
          loading: false,
        });
      });
  };
  setLoading = (documentPath) => {
    this.setState({
      pageLoad: true,
    });
    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };
    axios
      .get(
        process.env.REACT_APP_UPLOAD_DOWNLOAD +
          this.state.apiInterface +
          '/download?objectId=' +
          documentPath,
        {
          headers: headers,
          responseType: 'blob',
        }
      )
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        var re = /(?:\.([^.]+))?$/;

        var ext = re.exec(documentPath)[1]; // "txt"
        const MimeTypesMap = {
          png: 'image/png',
          gif: 'image/gif',
          jpg: 'image/jpg',
          jpeg: 'image/jpeg',
          pdf: 'application/pdf',
          mp4: 'video/mp4',
          doc: 'application/msword',
          docx:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ppt: 'application/vnd.ms-powerpoint',
          pptx: 'application/vnd.ms-powerpoint',
          xlsx:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        };

        const mimeType = MimeTypesMap[ext];

        const file = new Blob([response.data], { type: mimeType });
        //Build a URL from the file

        const fileURL = URL.createObjectURL(file);

        //Open the URL on new Window
        if (mimeType === 'application/pdf') {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentPath); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentPath); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
        this.setState({
          loading: false,
          pageLoad: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          pageLoad: false,
          modalOpen: false,
          message: 'Something went wrong please try again after sometime!!',
        });
      });
  };

  handleSearch = () => {
    // let some = [];
    // some = cities;
    // let cityIds = '';

    // if (typeof some === 'undefined') {
    //   cityIds = '';
    // } else {
    //   cityIds = cities && some.length > 0 && some.map((v) => v.value);
    // }
    // if (cityIds === false) {
    //   cityIds = '';
    // }
    this.setState({
      loading: true,
    });
    let m = localStorage.getItem('store_tabName');
    localStorage.setItem('currentCityForDashboard', this.state.currentCity);

    let storesForMultiSearch = JSON.parse(localStorage.getItem('storeData1'));

    let multiSearchData = JSON.parse(localStorage.getItem('multisearch'));
    //alert(JSON.stringify(multiSearchData));

    storesForMultiSearch.map((value) => {
      value.activeFlag = 0;

      JSON.parse(multiSearchData.data).map((val) => {
        if (val.label === value.storeName) {
          value.activeFlag = 1;
        }
      });
    });

    this.setState({
      storSearch: storesForMultiSearch,
    });
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    let userID = user['userId'];
    let data = {
      appType: 'Web',
      storeType: 'Store',
      storeIds: JSON.parse(multiSearchData.data).map((val) => val.value),
      userId: userID,
    };
    console.log('Update store is started');
    ApiGateWay.Post(this.state.apiInterface + '/updateCurrentStore', data)
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          this.setState({
            multiSearch: data,
            cityChanged: false,
          });
        }
        console.log('Update store is Done');
        ApiGateWay.Post(this.state.apiInterface + `/fetchStoreInfo`, {
          userId: this.state.userID,
          cityIds: this.state.currentCity,
          appType: 'Web',
        })
          .then((response) => response.json())
          .then((response) => {
            if (
              response.errorMessage === 'Token Expired' ||
              response.errorMessage === 'Invalid Token:::JWT expired' ||
              response.errorMessage ===
                'Your session has expired. Please login again.'
            ) {
              Cookie.remove('currentUser');
              Cookie.remove('stores');
              Cookie.remove('storesAll');
              Cookie.remove('warehouses');

              localStorage.clear();
              sessionStorage.clear();
              this.setState({
                loading: false,
                modalOpen: true,
                message:
                  'Your session has been expired and you will be redirected to the login page!!',
              });
              setTimeout(() => {
                return (window.location = '/');
              }, 4000);
            }

            if (response['storesInfos'][0]['storeType'] === 'Store') {
              localStorage.setItem(
                'storeData1',
                JSON.stringify(
                  response['storesInfos'][0]['storeLocationsInfos']
                )
              );
              console.log('Updated stores are generated');
              this.setState({
                navigate1: true,
                stores: response['storesInfos'][0]['storeLocationsInfos'],
              });
            } else {
              localStorage.setItem(
                'storeData1',
                JSON.stringify(
                  response['storesInfos'][1]['storeLocationsInfos']
                )
              );
              this.setState({
                navigate1: true,
                stores: response['storesInfos'][1]['storeLocationsInfos'],
              });
              console.log('Updated warehouse stores are generated');
            }
          })
          .catch(() => {
            this.setState({
              modalOpen: !this.state.modalOpen,
              message: 'Something went wrong please try again after sometime',
              loading: false,
            });
          });

        this.handleSelect(parseInt(m) ? parseInt(m) : 3);
      })
      .catch(() => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  };

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;
    future.map((val, index) =>
      val.value == 1
        ? !val.featureAccess
          ? val.featureName == 'Global Dashboard - Retail'
            ? (pageAllow = true)
            : ''
          : ''
        : ''
    );
    this.handleSearch();
    console.log('State is initialized in dashboard');
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
      });
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
    this.handleSelect(3);
  }

  render() {
    const {
      loading,
      currentMonth,
      years,
      month,
      currentyear,
      pageAllowed,
      modalOpen,
      cities,
      currentCity,
      cityChanged,
      navigate1,
      activeTab,
      pageLoad,
      storSearch,
      stores,
    } = this.state;

    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? val.featureAccess
              ? val.featureAccess.map((child1, ind) =>
                  child1.value == 1
                    ? child1.featureName == 'Global Dashboard - Retail'
                      ? (pageAllow = true)
                      : ''
                    : ''
                )
              : ''
            : ''
        )}
        {pageAllow === false ? (
         
          <Navigate to="/pageNotAllowed" state={{ id: 'Global Dashboard - Retail'}} />
        ) : (
          ''
        )}

        <Helmet>
          {' '}
          <title>{this.state.title}</title>{' '}
        </Helmet>

        {modalOpen ? (
          <MessageBox
            message={this.state.message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title='Global Dashboard - Retail' />
          <Menu />

          <div className='content-wrapper'>
            <section className='content'>
              <div className='row'> 
                <div className='col-md-2'>
                  <select
                    className='form-control'
                    value={currentMonth}
                    onChange={this.handleMonthChange}
                  >
                    <option>Month</option>
                    {month.map((monthName, monthValue) => (
                      <option
                        key={monthName + monthValue}
                        value={monthValue + 1}
                      >
                        {monthName}
                      </option>
                    ))}
                  </select>
                  </div>
                  <div className='col-md-2'>
                  <select
                    className='form-control'
                    value={currentyear}
                    onChange={this.handleYearChange}
                  >
                    <option>Year</option>
                    {years.map((year, yearValue) => (
                      <option key={yearValue} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  </div>
                <div className='col-md-2'>
                    <select
                      className='form-control'
                      value={currentCity}
                      onChange={this.handleCityChange}
                    >
                      <option value=''>All Cities</option>
                      {cities &&
                        cities.cityInfos
                          .sort((a, b) =>
                            a.cityName > b.cityName ? 1 : -1
                          )
                          .map((val, index) => (
                            <option key={val.cityId} value={val.cityId}>
                              {val.cityName}
                            </option>
                          ))}
                    </select>
                  </div>
                  <div className='col-md-2'>
                    <Multi
                      name='retail'
                      storSearch={storSearch}
                      stores={stores}
                      cityChanged={cityChanged}
                      navigate1={navigate1}
                      searchValue={this.state.searchValue}
                    />
                  </div>


                    
                      

                {/*  <div className='col-md-1 col-lg-1 col-sm-1 buttonsearchDiv '>
                  <button
                    type='submit'
                    onClick={this.handleSearch}
                    className='buttonsearch'
                  >
                    {' '}
                    <i className='fa fa-refresh'></i>
                  </button>
                </div> */}
                <div className='col-md-1'>
                  <div
                    // style={{
                    //   marginTop: '6px',
                    // }}
                  >
                    <button
                      type='submit'
                      onClick={this.handleSearch}
                      className='deca-btn-yellow'
                    >
                      {'Search'}
                    </button>
                  </div>
                </div>
                <div className='col-md-2 col-sm-12'>
                  
                    <Link to="/pdfExport" state={{ 
                               state: this.state,
                              }} >
                      
                      <button
                        className='deca-btn-yellow'
                        // style={{ marginBottom: '10px', marginTop: '35px' }}
                      >
                        Download Report
                      </button>
                    </Link>
                  </div>
              </div>

              {loading ? (
                <Spinner />
              ) : (
                <div className='row'>
                  
                  <div className='col-md-12'>
                    {/* Custom Tabs */}
                    <div className='nav-tabs-custom'>
                      <ul className='nav nav-tabs' id=''>
                        <li
                          className={this.state.activeTab === 3 ? 'active' : ''}
                          onClick={() => this.handleSelect(3)}
                        >
                          <a href='#tab_4' data-toggle='tab'>
                            Non Conformities
                          </a>
                        </li>
                        <li
                          className={this.state.activeTab === 4 ? 'active' : ''}
                          onClick={() => this.handleSelect(4)}
                        >
                          <a href='#tab_5' data-toggle='tab'>
                            Compliance & Contracts
                          </a>
                        </li>
                        <li
                          className={this.state.activeTab === 2 ? 'active' : ''}
                          onClick={() => this.handleSelect(2)}
                        >
                          <a href='#tab_3' data-toggle='tab'>
                            Handovers
                          </a>
                        </li>

                        <li
                          className={this.state.activeTab === 5 ? 'active' : ''}
                          onClick={() => this.handleSelect(5)}
                        >
                          <a href='#tab_6' data-toggle='tab'>
                            Training
                          </a>
                        </li>
                        <li
                          className={this.state.activeTab === 1 ? 'active' : ''}
                          onClick={() => this.handleSelect(1)}
                        >
                          <a href='#tab_2' data-toggle='tab'>
                            Incidents
                          </a>
                        </li>
                        <li
                          className={this.state.activeTab === 0 ? 'active' : ''}
                          onClick={() => this.handleSelect(0)}
                        >
                          <a href='#tab_1' data-toggle='tab'>
                            Evacuations
                          </a>
                        </li>
                      </ul>

                      <div className='tab-content'>
                        {this.state.activeTab === 0 ? (
                          <div className='tab-pane active' id='tab_1'>
                            <div className='row DataGridMain'>
                              <div className='col-md-8'>
                                {
                                  <DataTables
                                    type='retail'
                                    title='Evacuations'
                                    storeDashboard={false}
                                    tabIndex={activeTab}
                                    data={this.state.proxyjson}
                                    currentCity={currentCity}
                                    name='Evacuations'
                                    storeid=''
                                    year={currentyear}
                                    month={currentMonth}
                                  />
                                }
                              </div>
                              <div className='col-md-2'></div>
                            </div>

                            <br />
                            <br />
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.activeTab === 2 ? (
                          <div
                            className={
                              this.state.activeTab === 2
                                ? 'tab-pane active'
                                : 'close'
                            }
                            id='tab_3'
                          >
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  type='retail'
                                  title='Evacuations'
                                  storeDashboard={false}
                                  tabIndex={activeTab}
                                  data={this.state.proxyjson}
                                  currentCity={currentCity}
                                  name='Evacuations'
                                  storeid=''
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div>
                            <div className='row'>
                              <div className='col-md-8 close'>
                                <DataTables
                                  type='retail'
                                  title='Handovers'
                                  storeDashboard={false}
                                  tabIndex={activeTab}
                                  data={this.state.proxyjson}
                                  currentCity={currentCity}
                                  name='Handovers'
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                            </div>

                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  type='retail'
                                  title='Handovers'
                                  storeDashboard={false}
                                  tabIndex={activeTab}
                                  data={this.state.proxyJsonWeeklyCheckList}
                                  currentCity={currentCity}
                                  name='Handovers'
                                  storeid=''
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                            </div>

                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  type='retail'
                                  title='HandoversBSU'
                                  storeDashboard={false}
                                  tabIndex={activeTab}
                                  data={this.state.proxyJsonMonthlyCheckList}
                                  currentCity={currentCity}
                                  name='HandoversMonthlyBSU'
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.activeTab === 3 ? (
                          <div
                            className={
                              this.state.activeTab === 3
                                ? 'tab-pane active'
                                : 'close'
                            }
                            id='tab_4'
                          >
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  type='retail'
                                  title='Noncoformities'
                                  storeDashboard={false}
                                  tabIndex={activeTab}
                                  data={this.state.proxyJsonWeeklyCheckList}
                                  currentCity={currentCity}
                                  name='Nonconformities'
                                  dataClick={'Noncoformities'}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                            </div>
                            {/*  <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  type='retail'
                                  title='Evacuations'
                                  storeDashboard={false}
                                  tabIndex={activeTab}
                                  data={this.state.proxyjson}
                                  dataClick={'Noncoformities'}
                                  currentCity={currentCity}
                                  name='Evacuations'
                                  storeid=''
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div> */}
                            {/*  <div className='row'>
                              <div className='col-md-8 close'>
                                <DataTables
                                  type='retail'
                                  title='Noncoformities'
                                  storeDashboard={false}
                                  tabIndex={activeTab}
                                  data={this.state.proxyjson}
                                  currentCity={currentCity}
                                  name='Nonconformities'
                                  multisearch={multiSearch}
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                            </div> */}
                            <br />
                            <div className='row'>
                              <div className='col-md-10'>
                                <StackedBar
                                  mainTitle='Points Closed and Points Open'
                                  title={['Points Closed', 'Points Open']}
                                  label={this.state.proxyjson.stores}
                                  data={[
                                    this.state.proxyJsonWeeklyCheckList
                                      .totalCloseCount,
                                    this.state.proxyJsonWeeklyCheckList
                                      .totalOpenCount,
                                  ]}
                                />
                              </div>
                              {/*  <div className='col-md-6'>
                                <StackedBar
                                  mainTitle='Points Closed'
                                  title={['Points Closed']}
                                  label={this.state.proxyjson.stores}
                                  data={[
                                    this.state.proxyJsonWeeklyCheckList
                                      .totalCloseCount,
                                  ]}
                                />
                              </div> */}
                            </div>

                            <br />

                            <br />

                            <div className='row'>
                              <div className='col-md-12'>
                                <StackedBar
                                  mainTitle='Nonconfirm Points'
                                  title={[
                                    'Daily Count',
                                    'Weekly Count',
                                    'SOD Count',
                                    'Flows Count',
                                    'BSU Count',
                                    'Additional Count',
                                  ]}
                                  label={
                                    this.state.proxyJsonWeeklyCheckList.stores
                                  }
                                  data={[
                                    this.state.proxyJsonWeeklyCheckList
                                      .dailyCount,
                                    this.state.proxyJsonWeeklyCheckList
                                      .weeklyCount,
                                    this.state.proxyJsonWeeklyCheckList
                                      .sodCount,
                                    this.state.proxyJsonWeeklyCheckList
                                      .flowsCount,
                                    this.state.proxyJsonWeeklyCheckList
                                      .bsuCount,
                                    this.state.proxyJsonWeeklyCheckList
                                      .additionalCount,
                                  ]}
                                />
                              </div>
                            </div>
                            <br />
                            <br />
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.activeTab === 4 ? (
                          <div
                            className={
                              this.state.activeTab === 4
                                ? 'tab-pane active'
                                : 'close'
                            }
                            id='tab_5'
                          >
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  type='retail'
                                  title='Evacuations'
                                  storeDashboard={false}
                                  tabIndex={activeTab}
                                  data={this.state.proxyjson4}
                                  currentCity={currentCity}
                                  name='Evacuations'
                                  dataClick={'safetyRegister'}
                                  loading={this.setLoading}
                                  pageLoad={pageLoad}
                                  storeid=''
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div>
                            <div className='row'>
                              <div className='col-md-8'>
                                {/* <DataTables
                                type="retail"
                                title="Evacuations"
                                storeDashboard={false}
                                tabIndex={activeTab}
                                data={this.state.proxyjson}
                                name="Evacuations"
                                storeid=""
                                year={currentyear}
                                month={currentMonth}
                              /> */}
                              </div>
                              <div className='col-md-2'></div>
                            </div>

                            <br />
                            <br />
                          </div>
                        ) : (
                          ''
                        )}
                        {this.state.activeTab === 5 ? (
                          <div
                            className={
                              this.state.activeTab === 5
                                ? 'tab-pane active'
                                : 'close'
                            }
                            id='tab_5'
                          >
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  type='retail'
                                  title='Evacuations'
                                  storeDashboard={false}
                                  tabIndex={activeTab}
                                  data={this.state.proxyjson5}
                                  currentCity={currentCity}
                                  name='Evacuations'
                                  storeid=''
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div>
                            <div className='row'>
                              <div className='col-md-8'>
                                {/* <DataTables
                                type="retail"
                                title="Evacuations"
                                storeDashboard={false}
                                tabIndex={activeTab}
                                data={this.state.proxyjson}
                                name="Evacuations"
                                storeid=""
                                year={currentyear}
                                month={currentMonth}
                              /> */}
                              </div>
                              <div className='col-md-2'></div>
                            </div>

                            <br />
                            <br />
                          </div>
                        ) : (
                          ''
                        )}
                        <div className='tab-pane close' id='tab_7'>
                          <br />
                          <br />
                        </div>
                        {/* /.tab-pane */}
                        {this.state.activeTab === 1 ? (
                          <div
                            className={
                              this.state.activeTab === 1
                                ? 'tab-pane active'
                                : 'close'
                            }
                            id='tab_2'
                          >
                            <div className='row'>
                              <div className='col-md-8'>
                                <DataTables
                                  type='retail'
                                  title='Evacuations'
                                  storeDashboard={false}
                                  tabIndex={activeTab}
                                  data={this.state.proxyjson}
                                  currentCity={currentCity}
                                  name='Evacuations'
                                  dataClick={'incidents'}
                                  storeid=''
                                  year={currentyear}
                                  month={currentMonth}
                                />
                              </div>
                              <div className='col-md-2'></div>
                            </div>
                            <div className='row'>
                              <div className='col-md-8 close'>
                                {loading ? (
                                  <Spinner />
                                ) : (
                                  <DataTables
                                    title='Incidents'
                                    type='retail'
                                    storeDashboard={false}
                                    data={this.state.proxyjson}
                                    currentCity={currentCity}
                                    tabIndex={activeTab}
                                    name='Incidents'
                                    year={currentyear}
                                    month={currentMonth}
                                  />
                                )}
                              </div>
                            </div>

                            <br />
                            <br />
                            <div className='row' id='test'>
                              <div className='col-md-12'>
                                <StackedBar
                                  mainTitle='No of Incidents'
                                  title={[
                                    'No of incidents',
                                    'Incidents of mandatory closure',
                                    'Pending Approvals',
                                  ]}
                                  label={this.state.proxyjson.stores}
                                  data={[
                                    this.state.proxyjson.noOfIncidents,
                                    this.state.proxyjson.incidentsMC,
                                    this.state.proxyjson.pendingApprovals,
                                  ]}
                                />
                              </div>
                            </div>

                            <br />
                            <div className='spacer-mini'></div>
                            <div className='row'>
                              <div className='col-md-12 '>
                                <LineChart
                                  labels={this.state.proxyjson.stores}
                                  data={[this.state.closure]}
                                />
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-md-6'>
                                <DoughNut
                                  title='Count of Alert Levels'
                                  labels={this.state.alerts}
                                  data={this.state.alertno}
                                />
                              </div>
                              <div className='col-md-6'>
                                <PolarChart
                                  title='Different Types of Alerts'
                                  labels={this.state.incidentTypeNo}
                                  data={this.state.incno}
                                />
                              </div>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default Dashboard;
